<template>
  <div class="authentication-privacy">
    <div class="title">
      个人实名认证服务协议
    </div>
    <div class="privacy_text">本协议由以下方达成， 为确保双方权益，特制定如下合同：.</div>
    <div class="privacy_text" style="font-weight: bold;">一 、认证方</div>
    <div class="privacy_text">姓名：[认证方姓名](以下简称”认证方")</div>
    <div class="privacy_text" style="font-weight: bold;">二、被认证方</div>
    <div class="privacy_text" >姓名：[被认证方姓名]身份证号码：[被认证方身份证号码] (以下简称”被认证方”)</div>

    <div class="privacy_text" style="font-weight: bold;">三、 协议目的</div>
    <div class="privacy_text">本协议的目的是确保被认证方在新媒体平台上的身份真实、合
      法，并对双方权益进行明确保护。</div>

    <div class="privacy_text" style="font-weight: bold;">四、 认证方式</div>
    <div class="privacy_text">认证方将通过以下方式对被认证方进行实名认证：</div>
    <div class="privacy_text">1. 提交身份证照片或其他身份信息。</div>
    <div class="privacy_text">2. 提供有效的联系方式，以供认证方进一步核实。</div>

    <div class="privacy_text" style="font-weight: bold;">五 、被认证方权利和义务</div>
    <div class="privacy_text" >1. 被认证方应积极配合提供真实、完整的身份信息。</div>
    <div class="privacy_text" >2. 被认证方应确保所提供的信息真实、合法，并承担由此引起的一切责任。</div>
    <div class="privacy_text" >3. 被认证方有权在新媒体平台上以实名方式展示个人信息。</div>
    <div class="privacy_text" >4. 被认证方应及时更新个人信息，保证信息的准确性和时效性。</div>

    <div class="privacy_text" style="font-weight: bold;">六 、认证方权利和义务</div>
    <div class="privacy_text" >1. 认证方应对被认证方所提供的信息进行核实，并确保其真实性。</div>
    <div class="privacy_text" >2. 认证方应妥善保管被认证方的个人信息，不得非法使用或泄露。</div>
    <div class="privacy_text" >3. 认证方有权就被认证方的实名认证信息进行公示。</div>

    <div class="privacy_text" style="font-weight: bold;">七 、信息保护</div>
    <div class="privacy_text" >1. 双方应保护对方提供的相关信息的隐私，不得以任何形式泄
      露或非法使用信息。</div>
    <div class="privacy_text" >2. 若因信息泄露或非法使用造成损失，泄露方应承担相应的法
      律责任。</div>

    <div class="privacy_text" style="font-weight: bold;">八、 违约责任</div>
    <div class="privacy_text" >1. 若被认证方提供的身份信息不真实、不合法，认证方有权采
      取措施取消被认证方的实名认证资格。</div>
    <div class="privacy_text" >2. 若认证方未按约定妥善保管被认证方的个人信息，并造成信
      息泄露或非法使用的，认证方应承担相应责任。</div>

    <div class="privacy_text" style="font-weight: bold;">九 、争议解决</div>
    <div class="privacy_text" >本协议发生争议时，双方应友好协商解决，协商不成的，提交
      到认证方所在地的有管辖权的人民法院解决。</div>

    <div class="privacy_text" style="font-weight: bold;">十、 其他条款</div>
    <div class="privacy_text" >1. 本协议自双方签署之日起生效，有效期为[有效期限],期满
      后双方可协商决定是否续签。</div>
    <div class="privacy_text" >2. 本协议一式两份，双方各持一份具有同等法律效力。</div>
    <div class="privacy_text" >3. 本协议未尽事宜由双方协商决定。</div>
    <div class="privacy_text" >4. 本协议合法、有效，对双方具有约束力。</div>
  </div>

</template>

<script>

export default {
  name: 'AuthenticationPrivacy',
  data() {
    return {

    }
  },
  methods: {

  },
  created() {

  }
}

</script>


<style scoped lang="scss">

.authentication-privacy {
  padding: 16px;

  .title {
    font-size: 18px;
    color: #444;
    font-weight: 800;
    text-align: center;
    margin-bottom: 10px;
  }

  .privacy_text {
    font-size: 14px;
    color: #444;
    line-height: 28px;
    text-indent: 36px;
  }
}
</style>
